import { useContext } from 'react';
import { Placeholder } from 'react-bootstrap';
import PropTypes from 'prop-types';
import i18nContext from 'components/i18n-context';
import { formatDate } from 'services/utils';
import Button from 'uikit/Button/Button';
import './EmailValidationRulesTableRowContent.scss';

export const EmailValidationRulesTableRowContent = ({
  isLoading,
  emailValidationRuleData,
  handleDeleteEmailValidationRule
}) => {
  const i18n = useContext(i18nContext);

  const getEmailValidationRuleInfoBlock = (emailValidationRuleBlockInfo, isDeleteEmailValidationRule = false) => {
    if (isLoading) {
      return (
        <Placeholder as={'p'} animation={'glow'}>
          <Placeholder className={'email-validation-rules-table-loader-placeholder'} xs={12} bg={'secondary'} />
        </Placeholder>
      );
    } else if (isDeleteEmailValidationRule) {
      return (
        <Button
          onClick={() => handleDeleteEmailValidationRule(emailValidationRuleData.id)}
          type={'primary'}
          size={'small'}
        >
          {i18n.getMessage('emailValidationRules.table.button.delete')}
        </Button>
      );
    } else {
      return <p>{emailValidationRuleBlockInfo}</p>;
    }
  };

  return (
    <tr>
      <td className={'email-validation-rules-table-cell email-validation-rules-table-cell-rule'}>
        {getEmailValidationRuleInfoBlock(emailValidationRuleData.rule)}
      </td>
      <td className={'email-validation-rules-table-cell'}>
        {getEmailValidationRuleInfoBlock(
          i18n.getMessage(`emailValidationRules.action.${emailValidationRuleData.action}`)
        )}
      </td>
      <td className={'email-validation-rules-table-cell'}>
        {getEmailValidationRuleInfoBlock(formatDate(emailValidationRuleData.createdAt))}
      </td>
      <td className={'email-validation-rules-table-cell'}>
        {getEmailValidationRuleInfoBlock(emailValidationRuleData, true)}
      </td>
    </tr>
  );
};

EmailValidationRulesTableRowContent.propTypes = {
  isLoading: PropTypes.bool,
  handleDeleteEmailValidationRule: PropTypes.func,
  emailValidationRuleData: PropTypes.oneOfType([
    PropTypes.shape({
      id: PropTypes.number,
      rule: PropTypes.string,
      action: PropTypes.string,
      createdAt: PropTypes.string
    }),
    PropTypes.oneOf([null])
  ])
};
